import React from "react";

const Careers = () => {
  return (
    <main className="relative p-8 bg-fixed bg-cover bg-center bg-gray-900" style={{
      backgroundImage: `url(${require("../../assets/backdrops/career.png")})`,
    }}>
      <section className="relative container mx-auto text-center p-4 max-w-screen-xl bg-black bg-opacity-80 rounded-lg">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
          Careers - Join Our Esteemed Legal Team
        </h2>
        <p className="text-lg md:text-xl text-gray-200 max-w-3xl mx-auto leading-relaxed text-justify font-light opacity-80">
          At Amir Law Firm, we take immense pride in our position at the
          pinnacle of legal excellence, consistently delivering unparalleled
          services across a broad spectrum of practice areas. Our firm’s
          continued success is a testament to the dedication, expertise, and
          exceptional talent of our team members, who play an instrumental role
          in shaping our firm’s trajectory and reputation. <br />
          We are actively seeking dynamic, ambitious, and highly skilled legal
          professionals to join our esteemed team. Whether you are a seasoned
          attorney with a proven track record of success or a burgeoning legal
          talent eager to establish your mark in the legal arena, Amir Law Firm
          offers a stimulating and supportive environment designed to foster
          your professional growth and success. <br />
          Our firm is characterized by a culture that emphasizes collaboration,
          integrity, and innovation. We believe in nurturing an environment
          where creativity and strategic thinking are not only encouraged but
          are fundamental to our operations. As a member of our team, you will
          be afforded the opportunity to engage with cutting-edge legal
          resources, tackle meaningful and challenging cases, and contribute to
          high-impact work that influences the legal landscape. <br />
          We place a high value on diverse perspectives and are resolutely
          committed to cultivating an inclusive workplace. At Amir Law Firm,
          every individual’s voice is heard and valued, and we are dedicated to
          creating an environment where all team members feel respected and
          empowered. <br />
          We invite you to explore a rewarding career with us, where your
          expertise will be continuously refined, your contributions will be
          recognized and celebrated, and your professional journey will be
          enriched by engaging and impactful work. By joining Amir Law Firm, you
          become a part of a legacy of legal excellence and an integral player
          in our firm’s ongoing success. <br />
          Seize the opportunity to advance your career with a firm that stands
          at the forefront of the legal profession. Apply today to become a
          valued member of the Amir Law Firm team.
        </p>
      </section>
    </main>
  );
};

export default Careers;
